import { getUserSession } from './localStorage';

export function isAuthenticated() {
  const token = getUserSession();
  return !!token;
}


